// InputField.jsx
import React from "react";

const InputField = ({ as = "input", className = "", ...props }) => {
  const Component = as;

  return (
    <Component
      className={`w-full rounded-xl border border-border bg-surface text-body placeholder:text-body/60 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-accent-1 transition ${className}`}
      {...props}
    />
  );
};

export default InputField;
